export default class ScreenResolutionHelper {
    public static readonly SCREEN_WIDTH_4k: number = 3840

    public static is4KResolution(): boolean {
        return window.screen.width >= this.SCREEN_WIDTH_4k
    }

    public static getSizeFor4KResolution(size: number): number {
        return this.is4KResolution() ? size * 2 : size
    }
}
